var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{class:!(_vm.dataName && _vm.dataValue)
      ? 'mx-lg-3 mx-xl-3 py-lg-2 py-xl-2 account-list empty-account-list'
      : 'mx-lg-3 mx-xl-3 py-lg-2 py-xl-2 account-list'},[_c('b-col',{attrs:{"cols":"auto","align":"left"}},[_c('span',{class:_vm._isDesktop ? 'account-data-label' : 'account-data-label-mobile'},[(_vm.imageSrc)?_c('img',{staticClass:"mr-2",attrs:{"src":_vm.imageSrc}}):_vm._e(),_vm._v(" "+_vm._s(_vm.dataName)+" ")])]),_c('b-col',{class:_vm._isDesktop
        ? 'account-data-label-value'
        : 'account-data-label-value-mobile pl-0 ' + _vm.listClass,attrs:{"align":"right"}},[_c('span',[_vm._v(_vm._s(_vm.dataValue))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }